export default __webpack_public_path__ + "static/media/prism.7d72befd.png";